import { useEffect, useState } from 'react';

const navLinks = [
  { href: '#hot', label: '今日热搜' },
  { href: '#timeline', label: '事件时间线' },
  { href: '#review', label: '全经过复盘' },
  { href: '#topic', label: '瓜田分类' },
  { href: '#faq', label: '常见问题' },
  { href: '#about', label: '关于本站' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? 'bg-background-50/95 backdrop-blur border-b border-background-200/80 shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="container-x flex items-center justify-between h-16 md:h-[72px]" aria-label="主导航">
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-eye-fill text-lg" aria-hidden="true"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-xl font-bold text-foreground-950">每日看瓜</span>
            <span className="hidden sm:block text-[11px] tracking-wide text-secondary-700">瓜田时间线 · 始末复盘</span>
          </span>
        </a>

        <ul className="hidden md:flex items-center gap-7">
          {navLinks.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                className="whitespace-nowrap text-sm text-foreground-700 transition-colors hover:text-primary-600"
              >
                {l.label}
              </a>
            </li>
          ))}
          <li>
            <a
              href="#review"
              className="inline-flex whitespace-nowrap items-center rounded-md bg-primary-500 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              看最新复盘
            </a>
          </li>
        </ul>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden flex h-10 w-10 items-center justify-center rounded-md text-foreground-900 hover:bg-background-200"
          aria-label={open ? '关闭菜单' : '打开菜单'}
          aria-expanded={open}
        >
          <i className={open ? 'ri-close-line text-xl' : 'ri-menu-3-line text-xl'} aria-hidden="true"></i>
        </button>
      </nav>

      {open && (
        <div className="md:hidden border-t border-background-200/80 bg-background-50 px-4 pb-4">
          <ul className="flex flex-col gap-1 pt-2">
            {navLinks.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="block rounded-md px-3 py-2.5 text-sm text-foreground-800 hover:bg-background-100"
                >
                  {l.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href="#review"
                onClick={() => setOpen(false)}
                className="mt-2 block rounded-md bg-primary-500 px-3 py-2.5 text-center text-sm text-background-50"
              >
                看最新复盘
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}